import * as PIXI from 'pixi.js'
import { config } from './settings'

export const app = new PIXI.Application({
  width: config.originalWidth,
  height: config.originalHeight,
  backgroundColor: 0xFF0000,
  antialias: true,
  resolution: 2, // window.devicePixelRatio,
  backgroundAlpha: 0
})

globalThis.__PIXI_APP__ = app
